import React from 'react';

export default function ErrorHero() {
  return (
    <div className="flex flex-col items-center text-center">
      {/* 404 Number */}
      <h1
        className="text-[10rem] md:text-[12rem] font-bold leading-none select-none"
        style={{
          fontFamily: "'Cormorant Garamond', 'Georgia', serif",
          color: '#D4A520',
          textShadow: '0 0 40px rgba(212,165,32,0.5), 0 0 80px rgba(212,165,32,0.25)',
        }}
      >
        404
      </h1>

      {/* WIN Gold Coin Logo with pulse animation */}
      <div
        className="mt-2 mb-6"
        style={{
          animation: 'winLogoPulse 2s ease-in-out infinite',
        }}
      >
        <img
          src="/assets/images/Golden_coins_Win_Logo-1772863636273.png"
          alt="WIN Gold Coin Logo"
          className="w-20 h-20 object-contain"
        />
      </div>

      {/* Page Not Found heading */}
      <h2
        className="text-3xl font-semibold text-white mb-4"
        style={{ fontFamily: "'Cormorant Garamond', 'Georgia', serif" }}
      >
        Page Not Found
      </h2>

      {/* Gold divider */}
      <div
        className="w-16 mx-auto my-6"
        style={{ height: '1px', backgroundColor: '#D4A520' }}
      />

      {/* Message */}
      <p
        className="text-base max-w-md mx-auto"
        style={{ color: 'rgba(255,255,255,0.7)' }}
      >
        The page you're looking for doesn't exist or has been moved. Let's get you back on track.
      </p>
    </div>
  );
}
